export enum ProcedureType {
  POXA = 'PX',
  ALLEAMENTO_DIRECTO = 'AD',
  DISPOSICION_DECIMOSEXTA = 'VD',
  NEGOCIADO = 'PN'
}
